export const question = [
  {
    id: 1,
    question: "Eligibility",
    answer: [
      {
        item: "Women entrepreneurs 18 years and above.",
      },
      {
        item: "For companies or non individual entities, at least 51% ownership and controlling stake must be held by a woman.",
      },
      {
        item: "Applicant must not be in default with any bank or financial institution.",
      },
    ],
  },
  {
    id: 2,
    question: "Purpose of the Loan",
    answer: [
      {
        item: "To support women entrepreneurs in setting up new businesses or expanding existing enterprises.",
      },
      {
        item: "Applicable across manufacturing, trading, and services sectors, including activities allied to agriculture.",
      },
      {
        item: "Purchase of land may be permitted if it forms part of an approved project plan for manufacturing or services (subject to case by case approval).",
      },
    ],
  },
  {
    id: 3,
    question: "Loan Size",
    answer: [
      {
        item: "From ZMW 500,000 up to ZMW 10,000,000.",
      },
      {
        item: "Maximum loan exposure is 85% of the total project cost.",
      },
    ],
  },
  {
    id: 4,
    question: "Repayment Structure",
    answer: [
      {
        item: "Loan tenure of up to 84 months (7 years).",
      },
      {
        item: "Maximum moratorium period: 18 months.",
      },
      {
        item: "Door to door tenor must not exceed 84 months.",
      },
    ],
  },
  {
    id: 5,
    question: "Loan Type",
    answer: [
      {
        item: "Composite loan (Term Loan + Working Capital), including Fund Based and Non Fund Based facilities.",
      },
    ],
  },
  {
    id: 6,
    question: "Security Requirements",
    answer: [
      {
        item: "Primary security appropriate to the nature of the facility.",
      },
      {
        item: "Collateral security covering 50% of the loan exposure (immovable property, cash collateral, GRZ securities, etc.).",
      },
      {
        item: "Remaining 50% to be guaranteed by the Zambia Credit Guarantee Scheme for Indo Stand Up Loans for Women.",
      },
      {
        item: "Existing unencumbered factory buildings, land, or property may be considered toward the collateral requirement.",
      },
    ],
  },
  {
    id: 7,
    question: "Margin Contribution",
    answer: [
      {
        item: "Borrower must contribute a minimum of 15% of the project cost.",
      },
    ],
  },
];
